import React, { FC, useEffect } from 'react';
import { GoalsAndTargetsGrid } from './GoalsAndTargetsGrid';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box, TextField } from '@mui/material';
import { WorkforceProfileGoalsAndTargetsService } from '../../../../Component/Api/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileGoalsAndTargetsService';
import { IGoalAndTargetRow, WorkForceGoalAndTargetRowLookupValue } from '../../../Common/WorkforceProfile/GoalsAndTargetsCommon';
import { EEOccupationalLevel } from '../../../../Component/Model/Enum/EmploymentEquity';
import { toast } from 'react-toastify';
import _ from 'lodash';
import { useRecoilValue } from 'recoil';
import { ScorecardAtom } from '../../../../State/Scorecard.Atom';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { WorkforceProfileGoalsAndTargets } from '../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfileGoalsAndTargets/WorkforceProfileGoalsAndTargets';
import { Export } from '../../../../Component/Model/Dto/Export';
import { DataImportType } from '../../../../Component/Model/Enum/BEE123Enums';
import { CoreExportService } from '../../../../Component/Api/Export/CoreExportService';
import { LoadingButton } from '@mui/lab';
import { WorkforceComments } from './WorkforceComments';
import { getDateWithoutTime } from '../../../../Helpers/DateFormatter';
import { ValidatedMobileDatePicker } from '../../../../Component/Common/Components/ValidatedMobileDatePicker/ValidatedMobileDatePicker';

interface IGoalsProps {
    disabled: boolean,
    workforceProfileDate : Date;
    onDateChange: (date: Date) => void;
}

export const GoalsAndTargets: FC<IGoalsProps> = (props) => {
    const scorecard = useRecoilValue(ScorecardAtom);

    const [topManagementData, setTopManagementData] = React.useState<IGoalAndTargetRow[]>([]);
    const [seniorManagementData, setSeniorManagementData] = React.useState<IGoalAndTargetRow[]>([]);
    const [middleManagementData, setMiddleManagementData] = React.useState<IGoalAndTargetRow[]>([]);
    const [juniorManagementData, setJuniorManagementData] = React.useState<IGoalAndTargetRow[]>([]);
    const [semiSkilledData, setSemiSkilledData] = React.useState<IGoalAndTargetRow[]>([]);
    const [unskilledData, setUnskilledData] = React.useState<IGoalAndTargetRow[]>([]);
    const [temporaryData, setTemporaryData] = React.useState<IGoalAndTargetRow[]>([]);

    const [topManagementDataOpposite, setTopManagementDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [seniorManagementDataOpposite, setSeniorManagementDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [middleManagementDataOpposite, setMiddleManagementDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [juniorManagementDataOpposite, setJuniorManagementDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [semiSkilledDataOpposite, setSemiSkilledDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [unskilledDataOpposite, setUnskilledDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [temporaryDataOpposite, setTemporaryDataOpposite] = React.useState<IGoalAndTargetRow[]>([]);
    const [isExporting, setIsExporting] = React.useState<boolean>(false);

    const [commentData, setCommentData] = React.useState<WorkforceProfileGoalsAndTargets.CommentsDtoOut[]>([]);

    const [isLoading, setIsLoading] = React.useState({
        table: '',
        loading: false,
    });

    const [isFetchingAllData, setIsFetchingAllData] = React.useState(false);


    const setTableToLoadingStatus = (occupationalLevel: EEOccupationalLevel, status: boolean) => {
        let tableName = WorkForceGoalAndTargetRowLookupValue(occupationalLevel);

        setIsLoading({
            table: tableName,
            loading: status,
        })
    }

    function assignDataAndOpposite(newRow: any): [IGoalAndTargetRow, IGoalAndTargetRow] {
        let oppositeEmployees: IGoalAndTargetRow = {} as IGoalAndTargetRow;
        let allEmployees: IGoalAndTargetRow = {} as IGoalAndTargetRow;

        if (newRow.isDisabled) {
            allEmployees = newRow;
            oppositeEmployees = newRow;
            switch (newRow.occupationalLevel) {
                case EEOccupationalLevel.Top_Management:
                    allEmployees = topManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Senior_Management:
                    allEmployees = seniorManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Middle_Management:
                    allEmployees = middleManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Junior_Management:
                    allEmployees = juniorManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Semi_Skilled:
                    allEmployees = semiSkilledDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Unskilled:
                    allEmployees = unskilledDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Temporary:
                    allEmployees = temporaryDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
            }
        }
        else {
            oppositeEmployees = newRow;
            allEmployees = newRow;
            switch (newRow.occupationalLevel) {
                case EEOccupationalLevel.Top_Management:
                    oppositeEmployees = topManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Senior_Management:
                    oppositeEmployees = seniorManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Middle_Management:
                    oppositeEmployees = middleManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Junior_Management:
                    oppositeEmployees = juniorManagementDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Semi_Skilled:
                    oppositeEmployees = semiSkilledDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Unskilled:
                    oppositeEmployees = unskilledDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
                case EEOccupationalLevel.Temporary:
                    oppositeEmployees = temporaryDataOpposite.filter((x) => x.id === newRow.id)[0]
                    break;
            }
        }

        return [allEmployees, oppositeEmployees];
    }

    const compareDisabledAndAllEmployees = (newRow: any) => {
        let errorMessage: boolean = false;
        let [allEmployees, oppositeEmployees] = assignDataAndOpposite(newRow);

        const conditions = [
            [oppositeEmployees.femaleAfricanValue, allEmployees.femaleAfricanValue, "Disabled African Female is greater than Total African Female"],
            [oppositeEmployees.femaleColouredValue, allEmployees.femaleColouredValue, "Disabled Coloured Female is greater than Total Coloured Female"],
            [oppositeEmployees.femaleForeignNationalValue, allEmployees.femaleForeignNationalValue, "Disabled Foreign National Female is greater than Total Foreign National Female"],
            [oppositeEmployees.femaleIndianValue, allEmployees.femaleIndianValue, "Disabled Indian Female is greater than Total Indian Female"],
            [oppositeEmployees.femaleWhiteValue, allEmployees.femaleWhiteValue, "Disabled White Female is greater than Total White Female"],
            [oppositeEmployees.maleAfricanValue, allEmployees.maleAfricanValue, "Disabled African Male is greater than Total African Male"],
            [oppositeEmployees.maleColouredValue, allEmployees.maleColouredValue, "Disabled Coloured Male is greater than Total Coloured Male"],
            [oppositeEmployees.maleForeignNationalValue, allEmployees.maleForeignNationalValue, "Disabled Foreign National Male is greater than Total Foreign National Male"],
            [oppositeEmployees.maleIndianValue, allEmployees.maleIndianValue, "Disabled Indian Male is greater than Total Indian Male"],
            [oppositeEmployees.maleWhiteValue, allEmployees.maleWhiteValue, "Disabled White Male is greater than Total White Male"],
        ];

        for (const [OppositeValue, allValue, message] of conditions) {
            if (OppositeValue > allValue) {
                toast.error(message);
                errorMessage = true;
                break;
            }
        }

        return errorMessage;
    }

    const updateRowsInTable = (currentData: any[], updatedRows: any[]) => {
        return currentData.map((row) => {
            const updatedRow = updatedRows.find(updated => updated.id === row.id);
            return updatedRow ? { ...row, ...updatedRow } : row;
        });
    };

    const processRowUpdate = async (newRow: any, oldRow: any) => {
        if (_.isEqual(newRow, oldRow)) {
            return newRow;
        }
        try {
            if (compareDisabledAndAllEmployees(newRow)) {
                return oldRow;
            }

            setTableToLoadingStatus(newRow.occupationalLevel, true);
            const response = await WorkforceProfileGoalsAndTargetsService.SaveWorkforceProfileRow(newRow);

            const updatedRows = [
                response.data.table.find(row => row.id === newRow.id),
                response.data.table.find(row => row.id === newRow.id + 1)
            ];

            switch (response.data.occupationalLevel) {
                case EEOccupationalLevel.Top_Management:
                    setTopManagementData((prev) => updateRowsInTable(prev, updatedRows));
                    break;
                    case EEOccupationalLevel.Senior_Management:
                        setSeniorManagementData((prev) => updateRowsInTable(prev, updatedRows));
                        break;        
                    case EEOccupationalLevel.Middle_Management:
                        setMiddleManagementData((prev) => updateRowsInTable(prev, updatedRows));
                        break;      
                    case EEOccupationalLevel.Junior_Management:
                        setJuniorManagementData((prev) => updateRowsInTable(prev, updatedRows));
                        break;        
                    case EEOccupationalLevel.Semi_Skilled:
                        setSemiSkilledData((prev) => updateRowsInTable(prev, updatedRows));
                        break;      
                    case EEOccupationalLevel.Unskilled:
                        setUnskilledData((prev) => updateRowsInTable(prev, updatedRows));
                        break;    
                    case EEOccupationalLevel.Temporary:
                        setTemporaryData((prev) => updateRowsInTable(prev, updatedRows));
                        break;
                default:
                    console.log("Default")
                    break;
            }
            return newRow;

        } catch (error: any) {
            toast.error(error.response.data.title);
            return oldRow;
        } finally {
            setTableToLoadingStatus(newRow.occupationalLevel, false);
        }
    }

    const getWorkforceProfileGoalsAndTargetsData = async (date: Date) => {
        try {
            setIsFetchingAllData(true);
            const response = await WorkforceProfileGoalsAndTargetsService.GetWorkforceProfileGoalsAndTargetsData(scorecard.scorecardId, props.disabled, date);
            setTopManagementData(response.data.topManagement);
            setSeniorManagementData(response.data.seniorManagement);
            setMiddleManagementData(response.data.middleManagement);
            setJuniorManagementData(response.data.juniorManagement);
            setSemiSkilledData(response.data.semiSkilled);
            setUnskilledData(response.data.unskilled);
            setTemporaryData(response.data.temporary);

            const responseOpposite = await WorkforceProfileGoalsAndTargetsService.GetWorkforceProfileGoalsAndTargetsData(scorecard.scorecardId, !props.disabled, date);
            setTopManagementDataOpposite(responseOpposite.data.topManagement);
            setSeniorManagementDataOpposite(responseOpposite.data.seniorManagement);
            setMiddleManagementDataOpposite(responseOpposite.data.middleManagement);
            setJuniorManagementDataOpposite(responseOpposite.data.juniorManagement);
            setSemiSkilledDataOpposite(responseOpposite.data.semiSkilled);
            setUnskilledDataOpposite(responseOpposite.data.unskilled);
            setTemporaryDataOpposite(responseOpposite.data.temporary);

        } catch (error: any) {
            toast.error(error.response.data);
            console.log(error);
        } finally {
            setIsFetchingAllData(false);
        }
    }

    const exportWorkforceProfile = async () => {

        const request: Export.FileExportDto = {
            DataImportType: DataImportType.EEWorkforceProfile,
            parameters: [
                { key: 'date', value: props.workforceProfileDate },
                { key: 'isDisabled', value: props.disabled }
            ],
            scorecardId: scorecard.scorecardId
        };
        try {
            setIsExporting(true);
            let response = await CoreExportService.ExportFile(request);
            const redirectUrl = response.data;
            window.open(redirectUrl, '_blank');
        } catch (error) {
            console.log(error);
            toast.error("Export could not be completed");
        } finally {
            setIsExporting(false);
        }
    }

    const getComments = async () => {
        const response = await WorkforceProfileGoalsAndTargetsService.GetComments(scorecard.scorecardId, props.disabled)
        setCommentData(response.data);
    }

    useEffect(() => {
        getWorkforceProfileGoalsAndTargetsData(props.workforceProfileDate);
        getComments();
    }, [props.workforceProfileDate]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {/* Date picker */}

            <Box mb={1} mt={1} display="flex" justifyContent="space-between" alignItems="center">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ValidatedMobileDatePicker
                        label="Select Workforce Profile Actual Date"
                        inputFormat="yyyy/MM/dd"
                        mask="____/__/__"
                        value={props.workforceProfileDate}
                        onChange={(date: Date) => {
                            if (date) {
                                props.onDateChange(getDateWithoutTime(date));
                            }
                        }}
                        renderInput={(params: any) => <TextField {...params} sx={{ width: 300 }} />}
                        views={['year', 'month', 'day']}
                    />
                </LocalizationProvider>
                <LoadingButton variant="contained" color={"primary"} onClick={exportWorkforceProfile} loading={isExporting}>Export</LoadingButton>
            </Box>
            {/* Top Management */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Top Management" rows={topManagementData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'TopManagement')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Top_Management} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>        

            {/* Senior Management */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Senior Management" rows={seniorManagementData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'SeniorManagement')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Senior_Management} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

            {/* Professionally qualified and experienced specialists and mid-management */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Professionally qualified and experienced specialists and mid-management" rows={middleManagementData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'MiddleManagements')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Middle_Management} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

            {/* Skilled technical and academically qualified workers, junior management, supervisors, foremen, and superintendents */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Skilled technical and academically qualified workers, junior management, supervisors, foremen, and superintendents" rows={juniorManagementData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'JuniorManagement')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Junior_Management} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

            {/* Semi-skilled and discretionary decision making */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Semi-skilled and discretionary decision making" rows={semiSkilledData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'SemiSkilled')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Semi_Skilled} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

            {/* Unskilled and defined decision making */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Unskilled and defined decision making" rows={unskilledData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'Unskilled')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Unskilled} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

            {/* Temporary Employees */}
            <GoalsAndTargetsGrid isDisabled={props.disabled} title="Temporary Employees" rows={temporaryData} processRowUpdate={processRowUpdate} isLoading={isFetchingAllData || (isLoading.loading && isLoading.table === 'Temporary')} />
            <WorkforceComments comment={commentData} occupationalLevel={EEOccupationalLevel.Temporary} scorecardId={scorecard.scorecardId} isDisabled={props.disabled}/>     

        </>
    )
}
